module.exports = __webpack_public_path__ + "img/logo.5fc5bdc5.png";